import {
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	LineElement,
	PointElement,
	Title,
	Tooltip
} from 'chart.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import { getLastMonthsDate, processCustomCalenderDate } from '@features/crm/utils/helpers';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { convertDateToLocal } from '@utils/Util';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
	responsive: true,
	plugins: {
		legend: {
			display: false
		},
		title: {
			display: false,
			text: 'Chart.js Line Chart'
		}
	}
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
	labels,
	datasets: [
		{
			label: 'Dataset 1',
			data: [300, 400, 500, 800, 200, 100, 200],
			borderColor: 'rgb(255, 99, 132)',
			backgroundColor: 'rgba(255, 99, 132, 0.5)'
		},
		{
			label: 'Dataset 2',
			data: [100, 200, 300, 500, 200, 100, 600],
			borderColor: 'rgb(53, 162, 235)',
			backgroundColor: 'rgba(53, 162, 235, 0.5)'
		}
	]
};

const LineChart = () => {
	const [summary, setSummary] = useState({});
	const filterData = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();
	const { id } = useParams();

	const setDefaultFilterDates = async () => {
		let currentDate = moment().format('YYYY-MM-DD');
		let prevDate = getLastMonthsDate(Math.abs(6));
		let startDate = convertDateToLocal(prevDate, 'YYYY-MM-DD');
		let endDate = convertDateToLocal(currentDate, 'YYYY-MM-DD');
		let data = processCustomCalenderDate(startDate, endDate, 'Last 6 months');
		await dispatch(updateTextItemInGlobalFilter(data));
	};

	useEffect(() => {
		setDefaultFilterDates();
	}, []);

	const generateParams = () => {
		let params = `?brandId=${id}`;
		// let params = `?`;
		if (filterData.dateRange) {
			params += `&startDate=${filterData.dateRange[0].key.split('_')[0]}`;
			params += `&endDate=${filterData.dateRange[0].key.split('_')[1]}`;
		}
		return params;
	};

	const fetchBrandSummary = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.GET('getBrandSummary', generateParams());
			const noOfOrders = [];
			// const noOfQty = [];
			const noOfStyle = [];
			const nitexStyle = [];
			const labels = [];
			data.forEach((item) => {
				noOfOrders.push(item.noOfOrder);
				// noOfQty.push(item.quantity);
				noOfStyle.push(item.noOfBuyerStyle + item.noOfNitexStyle);
				nitexStyle.push(item.noOfNitexStyle);
				labels.push(
					`${moment()
						.month(item.month - 1)
						.format('MMM')} ${item.year.toString().substr(2, 2)}`
				);
			});
			setSummary({
				labels,
				datasets: [
					{
						label: 'No of Order',
						data: noOfOrders,
						borderColor: 'rgba(242, 43, 43, 1)',
						backgroundColor: 'rgba(242, 43, 43, 1)'
					},
					// {
					// 	label: 'No of Quantity',
					// 	data: noOfQty,
					// 	borderColor: 'rgb(53, 162, 235)',
					// 	backgroundColor: 'rgba(53, 162, 235, 0.5)'
					// },
					{
						label: 'Total Style',
						data: noOfStyle,
						borderColor: 'rgba(59, 130, 246, 1)',
						backgroundColor: 'rgba(59, 130, 246, 1)'
					},
					{
						label: 'Nitex Style',
						data: nitexStyle,
						borderColor: 'rgba(238, 118, 31, 1)',
						backgroundColor: 'rgba(238, 118, 31, 1)'
					}
				]
			});
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	useEffect(() => {
		if (filterData?.dateRange?.[0]?.key) {
			fetchBrandSummary();
		}
	}, [filterData]);

	return Object.keys(summary).length > 0 ? <Line options={options} data={summary} type={'line'} /> : '';
};

export default LineChart;
